<template>
  <!--
    No BlockFieldset at the root: it would also disable the card headers, so readers could not open
    a card. AccordionCard disables only its body.
  -->
  <div class="project-acceptance-report-data">
    <p v-if="isNewProject" class="text-muted">{{ $t('saveNewProjectFirst') }}</p>
    <template v-else>
      <MobileProjectsReport
        :project="project"
        :saveCard="saveCard"
        :reportTemplateImages="project.reportTemplateImages"
      />
      <ProjectReportVerificationRequest :project="project" :protocol="protocol" />
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MobileProjectsReport from '@/views/Projects/MobileProjectsReport';
import ProjectReportVerificationRequest from '@/blocks/project/report/ProjectReportVerificationRequest';

/** Number of the unsaved project (ProjectEdit `_new`). */
const NEW_PROJECT_NUMBER = '_new';

/**
 * Block project-acceptance-report-data ("Abnahmeprotokoll: Erfasste Daten", see feature page
 * projekt-protokolle): the cards, saved per card with "weiter"/"zurück" and the card state toggle,
 * with their photos and the four signatures; below them the section "13. Prüfung" with the four
 * states and a request button per state (the block project-acceptance-report-verification requests
 * too). `project` is the block data (`Project.blocks.acceptanceReportData`) with the reference data
 * of the cards.
 */
export default {
  name: 'ProjectAcceptanceReportData',
  components: { ProjectReportVerificationRequest, MobileProjectsReport },
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
    /** Config of the protocol (`reportProtocols.js`), passed by the tab; not imported here (cycle). */
    protocol: { type: Object, required: true },
  },
  computed: {
    isNewProject() {
      return this.project.number === NEW_PROJECT_NUMBER;
    },
  },
  methods: {
    ...mapActions(['updateProjectAcceptanceReportData']),
    saveCard(input) {
      return this.updateProjectAcceptanceReportData({ projectNumber: this.project.number, input });
    },
  },
};
</script>
